/* unplugin-vue-components disabled */import script from "./LoginRegister.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginRegister.vue?vue&type=script&lang=ts&setup=true"

import "./LoginRegister.vue?vue&type=style&index=0&id=c45db6b8&lang=scss&scoped=true"
import "./LoginRegister.vue?vue&type=style&index=1&id=c45db6b8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c45db6b8"]])

export default __exports__